import * as React from 'react';
import {
    DateField,
    EditButton,
    Show,
    SimpleShowLayout,
    TextField,
    TopToolbar,
    useShowContext
} from 'react-admin';
import {WrappedWithBackButton} from "../wrapped-with-back-button";
import {NoticeSendButton} from "./notice-send-button";

const NoticeShowActions = () => (
    <TopToolbar>
        <EditButton/>
        <NoticeSendButton />
    </TopToolbar>
);

const NoticeShowLayout = () => {
    const {
        error,
        isLoading
    } = useShowContext();

    if (isLoading) {
        return <div>Loading...</div>;
    }
    if (error) {
        return <div>Error!</div>;
    }
    return (
        <SimpleShowLayout>
            <TextField source="id" label={"ID"}/>
            <TextField source="title" label={"Cím"}/>
            <TextField source="content" label={"Tartalom"}/>
            <DateField source="createdAt" locales={['hu-HU']} label={"Létrehozva"}/>
        </SimpleShowLayout>
    );
};

export const NoticeShow = () => {
    return <WrappedWithBackButton>
        <Show title={'Üzenet'} actions={<NoticeShowActions/>}>
            <NoticeShowLayout/>
        </Show>
    </WrappedWithBackButton>;
};
